import React, { useState } from 'react';
import { MessageSquare, Play, Loader2 } from 'lucide-react';
import { useStore } from '../lib/store';
import { generateAIResponse } from '../lib/teachingService';
import ReactMarkdown from 'react-markdown';

export const ConversationContainer = () => {
  const { currentTeaching, conversations, addConversation } = useStore();
  const [isProcessing, setIsProcessing] = useState(false);

  if (!currentTeaching) return null;

  const handleClarify = async () => {
    try {
      setIsProcessing(true);
      const response = await generateAIResponse(currentTeaching);
      if (response) {
        addConversation(currentTeaching.id, {
          type: 'ai',
          content: response,
          timestamp: new Date()
        });
      }
    } catch (error) {
      console.error('Error generating response:', error);
    } finally {
      setIsProcessing(false);
    }
  };

  const currentConversations = conversations[currentTeaching.id] || [];

  return (
    <div className="mt-8 w-full max-w-4xl mx-auto p-6 rounded-lg bg-gradient-to-br from-gray-900 to-gray-800">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <MessageSquare className="w-6 h-6 text-amber-500" />
          <h2 className="text-2xl font-bold text-amber-500">Clarifying Thoughts & Questions</h2>
        </div>
        <button
          onClick={handleClarify}
          disabled={isProcessing}
          className="flex items-center gap-2 px-4 py-2 rounded-lg bg-amber-500 hover:bg-amber-600 transition-colors disabled:opacity-50 text-gray-900"
        >
          {isProcessing ? (
            <Loader2 className="w-5 h-5 animate-spin" />
          ) : (
            <Play className="w-5 h-5" />
          )}
          Help Me Clarify
        </button>
      </div>

      <div className="space-y-4">
        {currentConversations.map((conv, index) => (
          <div
            key={index}
            className="p-4 rounded-lg bg-gray-800"
          >
            <div className="prose prose-invert max-w-none">
              <ReactMarkdown>{conv.content}</ReactMarkdown>
            </div>
            <div className="text-xs text-gray-500 mt-2">
              {conv.timestamp.toLocaleTimeString()}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};